import assert from 'minimalistic-assert'

import createEthereumJsTx from './create-ethereumjs-tx.js'

export const signHardwareFactory =
  ({ baseAssetName }) =>
  async ({ unsignedTx, hardwareDevice, accountIndex }) => {
    const tx = createEthereumJsTx(unsignedTx)

    const signedTx = await signWithHardwareWallet({
      baseAssetName,
      tx,
      hardwareDevice,
      accountIndex,
    })

    // serialize and get txId
    const rawTx = signedTx.serialize()
    const txId = signedTx.hash().toString('hex')
    return { rawTx, txId }
  }

async function signWithHardwareWallet({ baseAssetName, tx, hardwareDevice, accountIndex }) {
  const rlpEncodedTx = tx.serialize()
  const signatures = await hardwareDevice.signTransaction({
    assetName: baseAssetName,
    signableTransaction: rlpEncodedTx,
    derivationPaths: [`m/44'/60'/${accountIndex}'/0/0`],
  })

  const { signature } = signatures[0]
  assert(signature.length >= 65, `signature length should be 65 or more`)
  const V_SIZE = signature.length - 64
  let v = Number.parseInt(signature.slice(0, V_SIZE).toString('hex'), '16')
  if (v === 0 || v === 1) {
    // _processSignature for EIP1559 expects 27 or 28.
    // hardware wallets on the other hand already precomputed the final v (0, 1).
    const diff = 27
    v += diff
  } else if (tx.common.chainId !== undefined) {
    // _processSignature for legacy transactions expects 27 or 28.
    // hardware wallets on the other hand already precomputed the final v (chainId * 2 + 35 + parity).
    const diff = tx.common.chainIdBN().muln(2).addn(8).toNumber()
    v -= diff
  }

  assert([27, 28].includes(v), `unexpected v-value, expected 27 or 28 but got ${v} `)
  const r = signature.slice(V_SIZE, V_SIZE + 32)
  const s = signature.slice(V_SIZE + 32, V_SIZE + 32 + 32)

  return tx._processSignature(v, r, s)
}
